import React from 'react';
import {
  Button, DialogActions, DialogContent, Dialog, Divider,
  IconButton, Typography, Checkbox, FormControlLabel, Box
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { connect } from 'react-redux';
import { setHistoricalMaterialFilter } from 'src/store/actions/materialActions';
import { FaTree } from "react-icons/fa";
import { GrTreeOption } from "react-icons/gr";
import { AiOutlineFullscreen, AiOutlineFullscreenExit } from "react-icons/ai";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "#FF9800",
    zIndex: 1301,
  },
  headerContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5)
  }
});

const useStyles = makeStyles((theme) => ({
  contentRoot: {
    padding: theme.spacing(3),
  },
  footerActions: {
    justifyContent: 'space-between', // Checkboxları iki yana ya da sıralı yayar
    padding: theme.spacing(1, 2),
    borderTop: `1px solid ${theme.palette.divider}`
  },
  searchTitle: {
    marginBottom: theme.spacing(2),
    fontWeight: 600
  }
}));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, subTitle, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <div className={classes.headerContent}>
        <Typography variant="h6" component="h2">{children}</Typography>
        {subTitle && (
          <Typography variant="body2" color="textSecondary" component="div">
            {subTitle}
          </Typography>
        )}
      </div>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const SelectDialog = (props) => {
  const classes = useStyles();
  const [labelTumuDaralt, setlabelTumuDaralt] = React.useState("Tümü");

  const handleChangeAgac = (e) => {
    props.setHistoricalMaterialFilter(e.target.checked ? 1 : 0);
  };

  const handleChangeFullMaterial = (e) => {
    props.setGosterimAdet(e.target.checked ? 100000 : 50);
    setlabelTumuDaralt(e.target.checked ? "Daralt" : "Tümü");
  };

  return (
    <Dialog
      fullScreen
      open={props.open}
      onClose={props.onClose}
      scroll="paper"
    >
      <DialogTitle
        onClose={props.onClose}
        subTitle={props.SelectedItems}
      >
        {props.title}
      </DialogTitle>

      <Divider />

      <DialogContent className={classes.contentRoot}>
        {props.SearchField && (
          <Typography variant="subtitle1" className={classes.searchTitle}>
            {props.SearchField}
          </Typography>
        )}
        {props.children}
      </DialogContent>

      {/* {props.actions && ( */}
      <DialogActions className={classes.footerActions}>
        {props.actions && (
          <Box display="flex" gridGap={16}>
            <FormControlLabel
              control={
                <Checkbox
                  icon={<GrTreeOption size='1.2em' />}
                  checkedIcon={<FaTree color='#FF9800' size='1.2em' />}
                  onChange={handleChangeAgac}
                />
              }
              label="Tarihsel Ağaç"
            />
            <FormControlLabel
              control={
                <Checkbox
                  icon={<AiOutlineFullscreen size='1.2em' />}
                  checkedIcon={<AiOutlineFullscreenExit color='#FF9800' size='1.2em' />}
                  onChange={handleChangeFullMaterial}
                />
              }
              label={labelTumuDaralt}
            />
          </Box>
        )}
        <Button onClick={props.onClose}
          color="secondary"
          endIcon={<CloseIcon>Close</CloseIcon>}
          variant="contained">
          Kapat
        </Button>
      </DialogActions>
      {/*  )}*/}
    </Dialog>
  );
};

const mapStateToProps = (state) => ({ ...state });
const mapDispatchToProps = { setHistoricalMaterialFilter };

export default connect(mapStateToProps, mapDispatchToProps)(SelectDialog);